import React from 'react'

interface Props {
  size?: number
}
export const SkipIcon: React.FC<Props> = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40">
    <defs>
      <linearGradient
        x1="39.315%"
        y1="99.576%"
        x2="81.296%"
        y2="-14.626%"
        id="skip_icon_a"
      >
        <stop stopColor="#FFD773" offset="0%" />
        <stop stopColor="#FEE37B" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle fill="url(#skip_icon_a)" cx="20" cy="20" r="20" />
      <path
        d="M3 16c0 11.046 8.954 20 20 20 5.646 0 10.745-2.34 14.382-6.102C33.939 35.932 27.445 40 20 40 8.954 40 0 31.046 0 20 0 14.6 2.14 9.701 5.617 6.103A19.904 19.904 0 003 16z"
        fillOpacity=".05"
        fill="#000"
      />
      <circle fill="#E8AD2B" cx="13.357" cy="19" r="2.5" />
      <circle fill="#E8AD2B" cx="26.643" cy="19" r="2.5" />
    </g>
  </svg>
)
